import type { TextFieldElementProps } from 'react-hook-form-mui';
import { TextFieldElement } from 'react-hook-form-mui';

import { useAppTranslations } from '@treneo/shared/i18n';

import { translateErrorMessage } from '../constants/form-constants';

type Props = TextFieldElementProps & {
  type?: string;
  name: string;
  label?: string;
  isRequired?: boolean;
};

export const TextField = ({ type, name, label, isRequired, ...props }: Readonly<Props>) => {
  const { t } = useAppTranslations();

  const parseError = (error: unknown) => {
    const message = translateErrorMessage(error);
    if (!message) {
      return '';
    }
    const translated = t(message);
    const hasTranslation = translated !== message;
    return hasTranslation ? translated : message;
  };

  return (
    <TextFieldElement
      {...props}
      type={type ?? 'text'}
      name={name}
      label={label}
      autoComplete={label}
      required={isRequired}
      parseError={parseError}
    />
  );
};
